<template>
  <div class="tags">
    <div class="tags__input-field">
      <div class="tags_selected">
        <md-chip
          v-for="tag in tags"
          :key="tag"
          class="md-primary"
          md-deletable
          @click="deleteChip(tag)"
        >
          {{ tag }}
        </md-chip>
      </div>
      <md-autocomplete
        v-model="selectValue"
        class="tags__input"
        :md-options="sbIndex"
        :md-fuzzy-search="false"
      >
        <label>Tags</label>
        <template
          slot="md-autocomplete-item"
          slot-scope="{ item, term }"
        >
          <md-highlight-text :md-term="term">
            {{ item }}
          </md-highlight-text>
        </template>
      </md-autocomplete>
    </div>
  </div>
</template>

<script>
    export default {
        name: "ServerBundlesForm",
        components: {
        },
        data() {
            return {
                sbIndex: [],
                sbList: [],
                componentKey : 0,
                selectValue: {

                },
            };
        },
        mounted() {
            this.getServerBundles();
        },
        methods: {
            getServerBundles() {
                this.$http.get("/v1/admin/node/server-bundles").then(
                    res => {
                        let tagNames = [];

                        res.data.tags.forEach(el => tagNames.push(el.name));

                        this.sbList = res.data.serverBundles;
                        this.sbIndex = tagNames;
                    },
                    err => {
                        console.error(err);
                    },
                );
            }
        },
    };
</script>

<style lang="scss">

</style>
